import { filter } from 'lodash';
import { Icon } from '@iconify/react';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import plusFill from '@iconify/icons-eva/plus-fill';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  TextField
} from '@mui/material';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import { useTranslation } from 'react-i18next';
// components
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import SearchNotFound from '../components/SearchNotFound';
import { UserListHead, UserListToolbar, UserMoreMenu } from '../components/_dashboard/user';
import Label from '../components/Label';
import NotifModal from '../components/_dashboard/user/NotifModal';
import Loader from '../components/_dashboard/user/Loader';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'nanny', label: 'nounou' },
  { id: 'email', label: 'email' },
  { id: 'phone', label: 'phone' },
  { id: 'class', label: 'classe' },
  { id: 'status', label: 'statut' },
  { id: 'action', label: 'action' }
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_user) =>
        _user.user.username.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        _user.user.email.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        _user.user.phone.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({}));

export default function NannyList() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [nanny, setNanny] = useState([]);
  const [checked, setChecked] = useState(null);
  const [checkedAll, setCheckedAll] = useState(false);
  const [list, setList] = useState([]);
  const [visible, setVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [notif, setNotif] = useState('');
  const [titleNotif, setTitleNotif] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation();

  const toggleModal = (data) => {
    setIsOpen(!isOpen);
    // setDataShare(data);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = nanny.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - nanny.length) : 0;

  const filteredUsers = applySortFilter(nanny, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  // GET all nanny
  const retrieveNanny = async () => {
    const token = localStorage.getItem('access');
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    const response = await axios({
      method: 'get',
      url: `${API_ENDPOINT}/api/get-all-nanny/`,
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  };

  useEffect(async () => {
    setIsLoading(true);
    const allNanny = await retrieveNanny();
    console.log('Nanny***', allNanny);
    if (allNanny) {
      setNanny(allNanny);
      setIsLoading(false);
    }
  }, []);

  const deactivate = (ID) => {
    const token = localStorage.getItem('access');
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    axios({
      method: 'PUT',
      url: `${API_ENDPOINT}/api/deactivate-user-from-admin/`,
      headers: { Authorization: `Bearer ${token}` },
      data: { id: `${ID}` }
    })
      .then((res) => {
        console.log('Deactivate user ID -->', ID);
        setNanny(
          nanny.map((c) => {
            if (c.user.id === ID) {
              c.user.is_active = false;
            }
            return c;
          })
        );
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  const activate = (ID) => {
    const token = localStorage.getItem('access');
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    axios({
      method: 'PUT',
      url: `${API_ENDPOINT}/api/activate-user-from-admin/`,
      headers: { Authorization: `Bearer ${token}` },
      data: { id: `${ID}` }
    })
      .then((res) => {
        console.log('activate user ID -->', ID);
        setNanny(
          nanny.map((c) => {
            if (c.user.id === ID) {
              c.user.is_active = true;
            }
            return c;
          })
        );
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  const toggleCheck = (inputName) => {
    setChecked((prevState) => {
      const newState = { ...prevState };
      newState[inputName] = !prevState[inputName];
      return newState;
    });
  };

  const selectAll = (value) => {
    setCheckedAll(value);
    setChecked((prevState) => {
      const newState = { ...prevState };
      Object.keys(newState).forEach((inputName) => (newState[inputName] = value));
      return newState;
    });
  };

  const kk = async () => {
    const allChildren = await retrieveNanny();
    const form = [];
    for (let i = 0; i < allChildren.length; i += 1) {
      form.push(allChildren[i].user.id);
    }
    const initialState = form.reduce((o, key) => ({ ...o, [key]: false }), {});
    setChecked(initialState);
  };

  useEffect(() => {
    kk();
    console.log('jjjjj=>', checked);
  }, []);

  useEffect(() => {
    if (checked != null) {
      console.log('uuuuu=>', checked);
      let allChecked = true;
      Object.keys(checked).forEach((inputName) => {
        if (checked[inputName] === false) {
          allChecked = false;
        }
      });
      if (allChecked) {
        setCheckedAll(true);
      } else {
        setCheckedAll(false);
      }
    }
  }, [checked]);

  useEffect(() => {
    if (checked != null) {
      let allChecked = false;
      Object.keys(checked).forEach((inputName) => {
        if (checked[inputName] === true) {
          allChecked = true;
        }
      });
      if (allChecked) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    }
  }, [checked]);

  const sel = () => {
    console.log('sellll==>', checked);
    const FormatData = [];
    Object.keys(checked).forEach((inputName) => {
      if (checked[inputName] === true) {
        FormatData.push(inputName);
      }
    });
    setList(FormatData);
    console.log('--- Ch ===> ---', FormatData);
    setIsOpen(!isOpen);
    // setDataShare(data);
  };

  return (
    <Page title={t('Listenounous')}>
      <Container>
        <Loader load={isLoading} />
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {t('Listenounous')}
          </Typography>
        </Stack>

        <Card>
          <UserListToolbar
            numSelected={visible}
            filterName={filterName}
            onFilterName={handleFilterByName}
            holder={`${t('search')}...`}
            click={sel}
            btnName={t('Ajouternotification')}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={nanny.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                  checkFunc={(event) => selectAll(event.target.checked)}
                  check={checkedAll}
                />
                <TableBody>
                  {filteredUsers
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                      const isItemSelected = selected.indexOf(row.user.username) !== -1;
                      const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
                      const pic = `${API_ENDPOINT}${row.user.photo}`;

                      return (
                        <TableRow
                          hover
                          key={row.id}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <StyledTableCell
                            component="th"
                            scope="row"
                            padding="none"
                            style={{
                              paddingLeft: document.body.dir === 'rtl' ? 0 : 20,
                              paddingRight: document.body.dir === 'rtl' ? 20 : 0
                            }}
                          >
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Checkbox
                                onChange={() => toggleCheck(row.user.id)}
                                checked={checked !== null && checked[row.user.id]}
                                sx={{
                                  color: '#f78181',
                                  '&.Mui-checked': {
                                    color: '#f78181'
                                  }
                                }}
                              />
                              <Avatar alt={row.user.username} src={pic} />
                              <Typography variant="subtitle2" noWrap>
                                {row.user.username}
                              </Typography>
                            </Stack>
                          </StyledTableCell>
                          <StyledTableCell>{row.user.email}</StyledTableCell>
                          <StyledTableCell>{row.user.phone}</StyledTableCell>
                          <StyledTableCell>{row.classe_code}</StyledTableCell>
                          <StyledTableCell>
                            <Label variant="ghost" color={row.user.is_active ? 'success' : 'error'}>
                              {row.user.is_active ? t('actif') : t('banni')}
                            </Label>
                          </StyledTableCell>
                          <StyledTableCell style={{ display: 'flex' }}>
                            <IconButton
                              onClick={() => activate(row.user.id)}
                              size="small"
                              aria-label="upload picture"
                              component="span"
                            >
                              <CheckIcon color="#a7b0b8" />
                            </IconButton>
                            <IconButton
                              onClick={() => deactivate(row.user.id)}
                              size="small"
                              aria-label="upload picture"
                              component="span"
                            >
                              <CloseIcon style={{ color: 'red' }} />
                            </IconButton>
                          </StyledTableCell>
                        </TableRow>
                      );
                    })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={nanny.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
        <NotifModal
          open={isOpen}
          notif={notif}
          setNotif={setNotif}
          title={titleNotif}
          setTitle={setTitleNotif}
          listId={list}
          clickCancel={() => {
            setIsOpen(false);
            setNotif('');
            setTitleNotif('');
            selectAll(false);
          }}
        />
      </Container>
    </Page>
  );
}
